import React from 'react';
import { Typography, Box } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslation } from 'react-i18next';
import convertIsoDatetimeToDate from '../../functions/convertIsoDatetimeToDate';

import DOMPurify from 'dompurify';

import { replacePlaceholderFields } from '../placeholders';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '&.MuiTypography-h6': {
      margin: theme.spacing(2),
    },
    '& img': {
      width: '100%',
    },
    '& figure': {
      margin: 'unset',
    },
    '& .image-style-side': {
      align: 'right',
    },
  },
  previewText: {
    lineHeight: 1.7,
    alignSelf: 'center',
  }
}));

const EmailPreview = (props) => {

  const { campaign, previewText } = props;

  const classes = useStyles();
  const { t } = useTranslation();
  const output = replacePlaceholderFields(previewText, campaign, 'email', 'html');
  const outputText = Array.isArray(output) ? output.join('') : output;

  return (
    <Box className="ck-content">
      <div className={classes.root}>
        <Typography variant="h6">{t('email-preview')}</Typography>
        <div className={classes.previewText} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(outputText) }} />
      </div>
    </Box>
  );
};

export default EmailPreview;
